import React from 'react';

import { Link } from 'react-router-dom';
import classes from './AssignmentQuizDetailsSection.module.css';
import ClockIcon from '../../../assets/icons/clock-blue.svg';
import CalendarIcon from '../../../assets/icons/calendar.svg';
import ProgressComponent from '../../UI/ProgressComponent/ProgressComponent';
import RouteEndPoints from '../../../utilities/RouteEndPoints';

const AssignmentQuizDetailsSection = (props) => {

    return (
        <div className={classes.DetailsSection}>
            <div className={[classes.CardContainer, classes.DetailsCard].join(' ')}>
                <p className={classes.CardHeading}>{props.type} Details</p>

                <p className={classes.TextLinkEdit} onClick={props.type === 'Quiz' ? props.showEditQuizPopup : props.showEditAssignmentPopup}>EDIT</p>

                <div className={classes.StatsDiv}>
                    <p className={classes.StatsCount}>
                        {props.result.totalProblems} <br />
                        <span className={classes.StatsText}>{props.type === 'Assignment' ? 'Problems' : 'Questions'}</span>
                    </p>
                    <p className={classes.StatsCount}>
                        {props.result.totalScore} <br />
                        <span className={classes.StatsText}>Total Score</span>
                    </p>
                    <p className={classes.StatsCount}>
                        {isNaN(props.result.passingScore) ? '-' : props.result.passingScore} <br />
                        <span className={classes.StatsText}>Pass Score</span>
                    </p>
                    {
                        props.type === 'Quiz'
                            ? <p className={classes.StatsCount}>
                                {props.result.timeLimit}
                                {
                                    props.result.timeLimit === '-'
                                        ? <span className={classes.StatsSubText}></span>
                                        : <span className={classes.StatsSubText}> min</span>
                                } <br />
                                <span className={classes.StatsText}>Time Limit</span>
                            </p>
                            : null
                    }
                </div>
                <hr className={classes.Divider} />
                <div className={classes.DatesContainer}>
                    <div>
                        <p className={classes.DateTimeHeading}>Start:</p>
                        <div className={classes.DateTimeDiv}>
                            <img src={CalendarIcon} alt="calender-icon" className={classes.Icon} />
                            <p className={classes.DateTimeText}>{props.type === 'Quiz' ? props.result.startDate : props.result.scheduleDate}</p>
                        </div>
                        <div className={classes.DateTimeDiv}>
                            <img src={ClockIcon} alt="clock-icon" className={classes.Icon} />
                            <p className={classes.DateTimeText}>{props.type === 'Quiz' ? props.result.startTime : props.result.scheduleTime}</p>
                        </div>
                    </div>
                    <div>
                        <p className={classes.DateTimeHeading}>Due:</p>
                        <div className={classes.DateTimeDiv}>
                            <img src={CalendarIcon} alt="calender-icon" className={classes.Icon} />
                            <p className={classes.DateTimeText}>{props.result.dueDate}</p>
                        </div>
                        <div className={classes.DateTimeDiv}>
                            <img src={ClockIcon} alt="clock-icon" className={classes.Icon} />
                            <p className={classes.DateTimeText}>{props.result.dueTime}</p>
                        </div>
                    </div>
                </div>

            </div>
            <div className={[classes.CardContainer, classes.OverviewCard].join(' ')}>
                <p className={classes.CardHeading}>{props.type} Overview</p>
                <div className={classes.ProgressComponentCard}>
                    <ProgressComponent
                        height="90px"
                        fontSize="14px"
                        label="Submissions"
                        overallPercentage={props.result.submissionProgress.value}
                        showProgressBar={true}
                        type="Fraction"
                        fractionText={props.result.submissionProgress.label} />
                </div>
                <div className={classes.ProgressComponentCard}>
                    <ProgressComponent
                        height="90px"
                        fontSize="14px"
                        label="Class Grade"
                        overallPercentage={props.result.classGrades}
                        showProgressBar={true}
                        type="Percentage" />
                </div>
                <Link className={classes.TextLink}
                    to={props.forPMPage === true
                        ? RouteEndPoints.PROGRAMS_PAGE + `/${props.batchCode}/modules/${encodeURIComponent(props.moduleName)}/evaluation/${props.type.toLowerCase()}/${props.result.topicId}`
                        : RouteEndPoints.EVALUATION_PAGE + '/' + props.batchCode + '/' + encodeURIComponent(props.moduleName) + '/' + props.type.toLowerCase() + '/' + props.result.topicId}>
                    VIEW SUBMISSIONS
                </Link>
            </div>
        </div>
    );
}

export default AssignmentQuizDetailsSection;